// Pagina publica /a-loja — A Loja / Quem Somos + horario de funcionamento. Sem login.
// Onda Google camada 1 — sinal de confianca (empresa real, endereco, horario) pro Merchant.
import { PaginaInstitucional, Secao } from './PaginaInstitucional';
import { LinksWhatsapp } from './LinksWhatsapp';

export function CatalogoPublicoLoja() {
  return (
    <PaginaInstitucional subtitulo="A Loja" titulo="A Loja">
      <p className="mt-4 text-sm leading-relaxed text-gray-700">
        A <strong>Fio de Cobre</strong> e uma loja fisica de materiais eletricos,
        acessorios para instalacao de ar condicionado e itens para piscina, em Sao Luis
        de Montes Belos, interior de Goias. Atendemos profissionais e clientes da regiao
        com produtos de qualidade e atendimento proximo.
      </p>

      <Secao titulo="Onde estamos">
        <p>
          Av. Rio da Prata, 920 — Setor Montes Belos
          <br />
          Sao Luis de Montes Belos / GO — CEP 76052-201
        </p>
      </Secao>

      <Secao titulo="Horario de funcionamento">
        <ul className="list-none pl-0 space-y-1">
          <li>
            <strong>Segunda a sexta:</strong> 7h as 18h
          </li>
          <li>
            <strong>Sabado:</strong> 8h as 12h
          </li>
          <li>
            <strong>Domingo:</strong> fechado
          </li>
        </ul>
      </Secao>

      <Secao titulo="Fale com a gente">
        <p>
          WhatsApp: <LinksWhatsapp className="font-medium" style={{ color: '#b45309' }} />
          <br />
          E-mail:{' '}
          <a
            href="mailto:atendimento@fiodecobre.com.br"
            className="font-medium"
            style={{ color: '#b45309' }}
          >
            atendimento@fiodecobre.com.br
          </a>
        </p>
        <p>
          Razao social: <strong>FIO DE COBRE LTDA</strong> — CNPJ 49.762.154/0001-00.
        </p>
      </Secao>

      <Secao titulo="Como comprar">
        <p>
          Consulte os produtos no nosso{' '}
          <a href="/catalogo" className="font-medium" style={{ color: '#b45309' }}>
            catalogo
          </a>
          , fale com a gente pelo WhatsApp ou venha a loja. A compra e finalizada e
          retirada presencialmente, sempre com nota fiscal. Detalhes na pagina{' '}
          <a href="/termos" className="font-medium" style={{ color: '#b45309' }}>
            Termos de Atendimento
          </a>
          .
        </p>
      </Secao>
    </PaginaInstitucional>
  );
}
